//#region src/bite_log_kiosk_event.ts
var BiteLogKioskEvent = /* @__PURE__ */ function(BiteLogKioskEvent) {
	BiteLogKioskEvent[BiteLogKioskEvent["OK"] = 0] = "OK";
	BiteLogKioskEvent[BiteLogKioskEvent["Update"] = 1] = "Update";
	BiteLogKioskEvent[BiteLogKioskEvent["TurnedOff"] = 2] = "TurnedOff";
	BiteLogKioskEvent[BiteLogKioskEvent["TurnedOffIndefinitely"] = 3] = "TurnedOffIndefinitely";
	BiteLogKioskEvent[BiteLogKioskEvent["TurnedOn"] = 4] = "TurnedOn";
	/** @deprecated */
	BiteLogKioskEvent[BiteLogKioskEvent["ApnSentDeprecated"] = 11] = "ApnSentDeprecated";
	/** @deprecated */
	BiteLogKioskEvent[BiteLogKioskEvent["ApnSendErrorDeprecated"] = 12] = "ApnSendErrorDeprecated";
	BiteLogKioskEvent[BiteLogKioskEvent["PushSent"] = 16] = "PushSent";
	BiteLogKioskEvent[BiteLogKioskEvent["PushSendError"] = 17] = "PushSendError";
	BiteLogKioskEvent[BiteLogKioskEvent["StatusMissing"] = 21] = "StatusMissing";
	BiteLogKioskEvent[BiteLogKioskEvent["StatusRecovered"] = 22] = "StatusRecovered";
	BiteLogKioskEvent[BiteLogKioskEvent["EnabledAda"] = 31] = "EnabledAda";
	BiteLogKioskEvent[BiteLogKioskEvent["EnableAdaError"] = 32] = "EnableAdaError";
	BiteLogKioskEvent[BiteLogKioskEvent["DisabledAda"] = 36] = "DisabledAda";
	BiteLogKioskEvent[BiteLogKioskEvent["DisableAdaError"] = 37] = "DisableAdaError";
	BiteLogKioskEvent[BiteLogKioskEvent["MovedMDMGroup"] = 41] = "MovedMDMGroup";
	BiteLogKioskEvent[BiteLogKioskEvent["MoveMDMGroupError"] = 42] = "MoveMDMGroupError";
	BiteLogKioskEvent[BiteLogKioskEvent["DeviceReboot"] = 43] = "DeviceReboot";
	BiteLogKioskEvent[BiteLogKioskEvent["DeviceRebootError"] = 44] = "DeviceRebootError";
	BiteLogKioskEvent[BiteLogKioskEvent["Inactive"] = 51] = "Inactive";
	return BiteLogKioskEvent;
}(BiteLogKioskEvent || {});
//#endregion
export { BiteLogKioskEvent };

//# sourceMappingURL=bite_log_kiosk_event.js.map